export * from './public_api';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /mnt/d/Projects/angular/chisparural-foro/~/angularfire2/auth/index.js
// module id = ../../../../angularfire2/auth/index.js
// module chunks = 4